export function Building({ ...rest }) {
  return (
    <svg {...rest} viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.58333 19.25V2.75H10.0833V5.5H17.4167V19.25H4.58333ZM6.41667 17.4167H8.25V15.5833H6.41667V17.4167ZM6.41667 13.75H8.25V11.9167H6.41667V13.75ZM6.41667 10.0833H8.25V8.25H6.41667V10.0833ZM6.41667 6.41667H8.25V4.58333H6.41667V6.41667ZM10.0833 17.4167H11.9167V15.5833H10.0833V17.4167ZM10.0833 13.75H11.9167V11.9167H10.0833V13.75ZM10.0833 10.0833H11.9167V8.25H10.0833V10.0833ZM13.75 17.4167H15.5833V15.5833H13.75V17.4167ZM13.75 13.75H15.5833V11.9167H13.75V13.75ZM13.75 10.0833H15.5833V8.25H13.75V10.0833Z"
        fill="#666666"
      />
    </svg>
  );
}
